
import { useState } from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Plus, X } from 'lucide-react';
import DocumentUpload from './DocumentUpload';
import DocumentsList from './DocumentsList';

const DocumentsTab = () => {
  const [showUpload, setShowUpload] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);

  const handleUploadSuccess = () => {
    setShowUpload(false);
    setRefreshKey(prev => prev + 1); // Force refresh of documents list
  };

  return (
    <div className="space-y-6">
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center justify-between">
            {showUpload ? 'Upload Legal Document' : 'Manage Documents'}
            <Button 
              onClick={() => setShowUpload(!showUpload)}
              variant={showUpload ? "outline" : "default"}
              className="flex items-center gap-2"
            >
              {showUpload ? (
                <>
                  <X className="h-4 w-4" />
                  Cancel
                </>
              ) : (
                <>
                  <Plus className="h-4 w-4" />
                  Add Document
                </>
              )}
            </Button>
          </CardTitle>
          <CardDescription>
            {showUpload 
              ? 'Upload PDF documents that will be linked in booking confirmations and terms dialogs'
              : 'View, activate/deactivate, and delete uploaded legal documents'
            }
          </CardDescription>
        </CardHeader>
        <CardContent>
          {showUpload ? (
            <DocumentUpload onUploadSuccess={handleUploadSuccess} />
          ) : (
            <DocumentsList key={refreshKey} />
          )}
        </CardContent>
      </Card>
    </div>
  );
};

export default DocumentsTab;
